import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import useSearch from "hooks/useSearch"
import { getMonitorProviderIns } from "store/monitor-receipts/monitor-receipt-action"
import {
  getMonitorIps,
  getMonitorItemCategories,
  getMonitorProjects,
  getMonitorProviders,
} from "store/monitor-dashboard/monitor-dashboard-action"
import MonitorReceiptsComponent from "components/MonitorReceipts/list"
import ProviderInDetailModal from "components/ProviderIn/details"
import { exportMonitorReceiptReport } from "store/monitor-reports/monitor-report-action"

const MonitorReceipts = () => {
  document.title = "Receipts"

  const exportStatus = useSelector(
    state => state.monitorReports.monitorExportReceiptReport
  )

  const dispatch = useDispatch()
  const { data, error, loading } = useSelector(state => state.monitorReceipts)
  const [proIn, setProIn] = useState(null)
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(10)
  const [according, setAccording] = useState({ order: "desc", name: "id" })
  const [advnacedSearch, setAdvancedSearch] = useState({})
  const [detailModal, setDetailModal] = useState(false)

  const onPageClick = link => {
    dispatch(
      getMonitorProviderIns(
        link.url,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }

  const onSearchHandler = value => {
    setSearch(value)
  }

  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  useSearch(
    getMonitorProviderIns(
      undefined,
      undefined,
      undefined,
      search,
      advnacedSearch
    ),
    search
  )

  useEffect(() => {
    dispatch(
      getMonitorProviderIns(
        undefined,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }, [pageNumber, according])

  useEffect(() => {
    dispatch(getMonitorItemCategories())
    dispatch(getMonitorIps())
    dispatch(getMonitorProjects())
    dispatch(getMonitorProviders())
  }, [])

  const onAdvancedSearchSubmit = data => {
    setAdvancedSearch(data)
    dispatch(
      getMonitorProviderIns(undefined, undefined, undefined, search, data)
    )
  }

  const onClickDetail = data => {
    setProIn(data)
    setDetailModal(true)
  }

  const onExportBtnClick = () => {
    dispatch(
      exportMonitorReceiptReport(pageNumber, according, search, advnacedSearch)
    )
  }

  return (
    <React.Fragment>
      <Breadcrumbs title={"Monitor"} breadcrumbItem={"Receipts"} />
      <ProviderInDetailModal
        data={proIn}
        open={detailModal}
        setOpen={setDetailModal}
      />
      <MonitorReceiptsComponent
        data={data}
        error={error}
        loading={loading}
        onPageClick={onPageClick}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
        onClickDetail={onClickDetail}
        onExportBtnClick={onExportBtnClick}
        exportStatus={exportStatus}
      />
    </React.Fragment>
  )
}

export default MonitorReceipts
